import { injectable, inject } from 'inversify';

import ThirdPartyTypes from '../../di/ThirdPartyTypes';
import IAppStateStorage from './IAppStateStorage';

const DISABLE_CREDIT_INFORMATION_FLOW = 'atto.disableCreditInformationFlow';

@injectable()
export default class AppStateStorage implements IAppStateStorage {
  @inject(ThirdPartyTypes.SessionStorage)
  private sessionStorage!: Storage;

  setDisableCreditInformationFlow(disable: boolean): void {
    this.sessionStorage.setItem(DISABLE_CREDIT_INFORMATION_FLOW, String(disable));
  }

  getDisableCreditInformationFlow(): boolean {
    return this.sessionStorage.getItem(DISABLE_CREDIT_INFORMATION_FLOW) === String(true);
  }
}
